/**
 * Rutten "/" för inloggade: telefon som valt Field (utils/versionsVal.js)
 * skickas till Field, alla andra till startsidan.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { skaStartaIField } from '../../utils/versionsVal';

export default function StartOmdirigering() {
  return <Navigate to={skaStartaIField() ? '/field' : '/home/overview'} replace />;
}
